import { render, staticRenderFns } from "./LbaCode.vue?vue&type=template&id=5b1f0563"
import script from "./LbaCode.vue?vue&type=script&lang=js"
export * from "./LbaCode.vue?vue&type=script&lang=js"
import style0 from "./LbaCode.vue?vue&type=style&index=0&id=5b1f0563&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports